import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 0C0.447715 0 0 0.447715 0 1V23C0 23.5523 0.447715 24 1 24H11V21C11 20.5 11.2 20 11.6 19.6L19.6 11.6C19.7246 11.4754 19.859 11.3701 20 11.2843V7C20 6.73478 19.8946 6.48043 19.7071 6.29289L13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0H1ZM19 24H18.8L18.8 24H19.0079C19.0053 24 19.0026 24 19 24ZM18 22L24 16L21 13L13 21V24H16L18 22ZM13 7V2L18 7H13ZM12 12H3V10H12V12ZM3 17H8V15H3V17Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }